import { IncidentDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IncidentService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getIncident(): Observable<IncidentDto[]> {
    return this.http.get<IncidentDto[]>(
      this.url + 'incident'
    );
  }

  createIncident(data: IncidentDto): Observable<IncidentDto> {
    return this.http.post<IncidentDto>(
      this.url + 'incident',
      data
    );
  }

  createAreaOfImpact(type: string, data: any[]): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };

    return this.http.post<any[]>(
      this.url + "incident/create?type=" + type,
      data,
    );
  }

  getSingleIncident(id: string): Observable<any> {
    return this.http.get(this.url + 'incident/' + id);
  }

  updateIncident(
    data: IncidentDto
  ): Observable<IncidentDto> {
    return this.http.post<IncidentDto>(
      this.url + 'incident/update',
      data
    );
  }

  fetchIncident(query: any): Observable<IncidentDto[]> {
    return this.http.post<IncidentDto[]>(this.url + "incident/fetch", query);
  }

  fetchByIdIncident(id: any): Observable<IncidentDto[]> {
    return this.http.post<IncidentDto[]>(this.url + "incident/fetchById", {id});
  }

  deleteIncident(id: string) {
    return this.http.post(this.url + 'incident/delete/' + id, {});
  }
}
